// extracted by mini-css-extract-plugin
module.exports = {"parity":"Parity_parity__R6xSo","parity__wrapper":"Parity_parity__wrapper__ipKXQ","parity__text":"Parity_parity__text__tcjJ2"};